import Button from './button.vue'
import Modal from './modal.vue'
import { getExtension, extensionsDocs, isAcceptable, hasVersions } from './view'
import routes from './routes'

let setEditableChecker = (fn: (upload: {}) => boolean) => (checkIfEditable = fn)

export {
  Button,
  getExtension,
  extensionsDocs,
  isAcceptable,
  hasVersions,
  routes,
  Modal,
  setEditableChecker,
}

export let checkIfEditable = (upload: {}) => true
